import t from '@zh-or/lib';
import u from './tools.js';
import api from '@/api/api.js';
import {isDebug} from './env.js';
import {userStore} from './store.js';
import jumpLogin from "./jumpLogin.js";
import notify from '@zh-or/lib/notify.js';

let isInit = false;
let doing = false;
let waitKey = 'waitInit';

export default async function waitInit(cb) {
    let user = userStore();

    if(isInit) {
        cb();
        return;
    }

    if(!u.isWeChat()) {
        if(isDebug) {
            console.log('当前不在微信浏览器内打开!');
        } else {
            u.goErrPage('请在微信浏览器打开')
            return;
        }
    }

    if(doing) {
        notify.lock(waitKey).wait().then(cb);
        return ;
    }
    doing = true;
    //let token = sessionStorage.getItem('token') || '';
    let token = user.token || '';
    if(!token) {
        let code = t.getQueryString('code');
        if(!code) {
            jumpLogin();
            return ;
        }

        try {
            t.showWait('登录中...');
            let login = await api.login({code: code});
            if(login.code === 1) {
                user.setUserInfo(login.data);
                //sessionStorage.setItem('info', login.data);
                //sessionStorage.setItem('token', login.data.openid);
            } else {

                jumpLogin();
                return ;
            }
        } catch(e) {
            console.error('登录失败:', e);
            t.hideWait();
            t.showToast('登录失败!');
            return;
        }
    }
    Promise.all([
        api.userInfo(),
        api.sign({
            url: encodeURIComponent(location.origin + location.pathname + location.search)
        }),
        u.loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js'),

    ])
        .then(([userInfo, login, jweixin]) => {
console.log('开始初始化!!!', login);
            if(userInfo.code !== 1 || !userInfo.data) {
                jumpLogin();
                return;
            }
            /*if(userInfo.data.img && userInfo.data.img.length > 0) {
                userInfo.data.url = userInfo.data.img[0].url;
            } else {
                userInfo.data.url = '';
            }*/

            user.setUserInfo(userInfo.data);
            //sessionStorage('info', userInfo.data);
            //sessionStorage.setItem('token', userInfo.data.openid);
            let sign = JSON.parse(login.data);
            console.log(sign);
            wx.config({
                //debug: env.isDev, 
                debug: false,
                //debug: true,
                appId: sign.appId, // 必填，公众号的唯一标识
                timestamp: sign.timestamp, // 必填，生成签名的时间戳
                nonceStr: sign.nonceStr, // 必填，生成签名的随机串
                signature: sign.signature,// 必填，签名
                jsApiList: ['chooseWXPay', 'scanQRCode',
                    'launchMiniProgram', 'openLocation',
                    'chooseImage'], // 必填，需要使用的JS接口列表
                openTagList:['wx-open-launch-weapp', 'wx-open-subscribe'],
            });
            wx.error(function(res) {
                console.error('微信初始化失败:', res);
                t.showToast('初始化失败');
                doing = false;
            });
            wx.ready(function() {
                console.log('微信初始化完成');
                t.hideWait();
                isInit = true;
                doing = false;
                notify.lock(waitKey).notify();
                cb();
            });
        })
        .catch(e => {
            t.hideWait();
            console.error('初始化失败:', e);
        })
}
